import _objectSpread from "E:\\xinyongban\\xinyidai-frontend\\node_modules\\@babel\\runtime-corejs2/helpers/esm/objectSpread";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "E:\\xinyongban\\xinyidai-frontend\\node_modules\\@babel\\runtime-corejs2/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.function.name";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { dataUpload, historydata, historyDownload } from "../../api/authmanget";
export default {
  computed: {
    getSourceType: function getSourceType() {
      return this.$store.getters.sourceType;
    }
  },
  data: function data() {
    return {
      activeName: "first",
      dialogHistory: false,
      lookTabData: [],
      dataTotal: 0,
      created: "",
      //用户名
      fileListdata: [],
      //信易贷文件
      selectedFile: null,
      historFrom: {
        page: 1,
        pageSize: 10
      },
      // year: "",
      month: "",
      days: "",
      Name: "",
      msg: ""
    };
  },
  mounted: function mounted() {
    this.created = sessionStorage.getItem("userName") || "未知用户";
  },
  methods: {
    // tab切换事件
    handleClick: function handleClick(tab, event) {
      if (tab.name === "second") {
        this.$refs.trustList.getBankList(); // 直接调用子组件方法
      } else if (tab.name === "center") {
        this.$refs.centerList.trustData(); // 直接调用子组件方法
      }

      console.log(tab.name, "dd");
    },
    // 下载excel模板
    xiazai: function xiazai() {
      var xhr = new XMLHttpRequest();
      xhr.open("get", this.baseUrl + "/api/v1/bankLicense/downloadLoanInfoExcel", true); // get、post都可

      xhr.responseType = "blob"; // 转换流

      xhr.setRequestHeader("token", sessionStorage.getItem("token")); // token键值对

      xhr.setRequestHeader("Content-Type", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8");

      xhr.onload = function () {
        if (this.status === 200) {
          // const blob = this.response;
          var blob = this.response;
          var fileName = "信易贷业务反馈.xlsx";

          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            var a = document.createElement("a");
            var url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
          }
        }
      };

      xhr.send();
    },
    // 选择文件按钮
    seletFile: function seletFile() {
      // 每次点击选择文件先进行清空
      this.$refs.excelUpload.clearFiles();
      this.Name = "";
    },
    // 移除文件事件
    handleRemovedata: function handleRemovedata() {
      this.selectedFile = null;
      this.Name = "";
    },
    // 上传excel模板成功回调
    handleAvatarSuccess: function handleAvatarSuccess(res) {
      console.log(res, "res回调");

      if (res.data.code == 200) {
        this.$refs.excelUpload.clearFiles(); // this.reason = res.msg;

        this.Name = "";
      } else {
        this.$refs.excelUpload.clearFiles(); // this.reason = res.msg;

        this.Name = "";
      }
    },
    // 文件改变时候的状态
    handName: function handName(file, fileList) {
      var isExcel = /\.(xlsx|xls)$/i.test(file.name);
      var isLt10M = file.size / 1024 / 1024 < 10;

      if (!isExcel) {
        this.$message.error("只能上传Excel文件!");
        this.$refs.excelUpload.clearFiles();
        return false;
      }

      if (!isLt10M) {
        this.$message.error("文件大小不能超过10MB!");
        return false;
      }

      var fileInput = this.$refs.excelUpload.$el.querySelector("input[type=file]");
      if (fileInput) fileInput.value = "";

      if (fileList.length > 0) {
        this.selectedFile = file.raw; // 保存原始文件对象
      } else {
        this.selectedFile = null;
      }

      this.Name = file.name;
      return true;
    },
    // 上传
    handleUpload: function () {
      var _handleUpload = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var created, formData, res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.selectedFile) {
                  _context.next = 3;
                  break;
                }

                this.$message.warning("请先选择文件");
                return _context.abrupt("return");

              case 3:
                _context.prev = 3;
                created = sessionStorage.getItem("userName") || "未知用户";
                formData = new FormData();
                formData.append("file", this.selectedFile);
                formData.append("created", created);
                _context.next = 10;
                return dataUpload(formData, {
                  headers: {
                    "Content-Type": "multipart/form-data"
                  }
                });

              case 10:
                res = _context.sent;
                this.handleAvatarSuccess(res);

                if (res.data.code == 200) {
                  this.$message.success(res.data.msg);
                } else {
                  this.$message.error(res.data.msg);
                }

                this.$refs.excelUpload.clearFiles();
                this.selectedFile = null;
                _context.next = 20;
                break;

              case 17:
                _context.prev = 17;
                _context.t0 = _context["catch"](3);
                console.log(_context.t0, "error"); // this.$message.error(error.response?.data?.message || "上传失败");

              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[3, 17]]);
      }));

      function handleUpload() {
        return _handleUpload.apply(this, arguments);
      }

      return handleUpload;
    }(),
    //  历史记录
    goHistory: function () {
      var _goHistory = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.dialogHistory = true;
                _context2.next = 3;
                return historydata(_objectSpread({}, this.historFrom, {
                  created: this.created
                }));

              case 3:
                res = _context2.sent;
                this.lookTabData = res.data.data;
                this.dataTotal = res.data.data.tatol;

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function goHistory() {
        return _goHistory.apply(this, arguments);
      }

      return goHistory;
    }(),
    // 历史记录下载
    downlUpload: function () {
      var _downlUpload = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee3(row) {
        var _ref, filename, blobData, contentType, blob, downloadUrl, link;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return historyDownload({
                  fileName: row.file_name
                });

              case 3:
                _ref = _context3.sent;
                filename = _ref.filename;
                blobData = _ref.blobData;
                contentType = _ref.contentType;
                blob = new Blob([blobData], {
                  type: contentType
                });
                downloadUrl = window.URL.createObjectURL(blob);
                link = document.createElement("a");
                link.href = downloadUrl; // 设置下载文件名（可以从响应头获取，也可以固定）

                link.download = filename;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link); // 释放URL对象

                window.URL.revokeObjectURL(downloadUrl);
                _context3.next = 22;
                break;

              case 18:
                _context3.prev = 18;
                _context3.t0 = _context3["catch"](0);
                this.$message.error("下载失败，请重试");
                console.log(_context3.t0);

              case 22:
                console.log(row, "row");

              case 23:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 18]]);
      }));

      function downlUpload(_x) {
        return _downlUpload.apply(this, arguments);
      }

      return downlUpload;
    }(),
    // 分页
    handleSizeChange: function handleSizeChange(val) {
      this.historFrom.pageSize = val;
      this.goHistory(this.historFrom);
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.historFrom.page = val;
      this.goHistory(this.historFrom);
    }
  }
};